import { Fragment, useState } from 'react';

import { Loader } from '@thinknet-gmbh/platform-common-ui';
import { EmployeeQuestionnaireStatusesEnum } from '@thinknet-gmbh/platform-common';

import { useRouteQuery } from 'src/common/helpers';
import { useGetEmployeeQuestionnaireSettingById } from 'src/hooks/employee-questionnaire-settings/get-employee-questionnaire-settings-by-id.hook';

import NotFoundPage from 'src/pages/not-found/not-found.page';
import { QuestionnairePageComponent } from 'src/components/questionnaire-page';
import { QuestionnaireThank } from 'src/components/questionnaire-page/components/questionnaire-thank';

import { QuestionnaireLayoutWrapper } from './questionnaire-preview.styles';
import { IQuestionnaireFormData } from './questionnaire-preview.interfaces';

const QuestionnairePreviewComponent = () => {
  const [data, setData] = useState({});
  const [status, setStatus] = useState<string>('');

  const params = useRouteQuery();
  const id = params.get('id') || '';

  const { questionnaireSetting, loading } = useGetEmployeeQuestionnaireSettingById(id);


  const onSubmitData = () => {
    setStatus(EmployeeQuestionnaireStatusesEnum.received);
  };

  const handleDataSet = (values: IQuestionnaireFormData) => {
    setData(oldValue => ({ ...oldValue, ...values }));
  };

  const questionnaireData = {
    questionnaireSettingsId: id,
    _id: '',
    companyId: '',
    jobId: '',
    jobLocationId: '',
    status: '',
    employeePersonalInfo: {
      firstName: '',
      lastName: '',
      email: '',
    },
  };

  return (
    <QuestionnaireLayoutWrapper>
      {loading ? (
        <Loader />
      ) : (
        <Fragment>
          {questionnaireSetting?._id ? (
            <Fragment>
              {status !== EmployeeQuestionnaireStatusesEnum.received ? (
                <QuestionnairePageComponent
                  questionnaireData={questionnaireData}
                  data={data}
                  handleDataSet={handleDataSet}
                  onSubmit={onSubmitData}
                />
              ) : (
                <QuestionnaireThank />
              )}
            </Fragment>
          ) : (
            <NotFoundPage />
          )}
        </Fragment>
      )}
    </QuestionnaireLayoutWrapper>
  );
};

export default QuestionnairePreviewComponent;
